import DevicesIcon from '@mui/icons-material/Devices';
import Button from "components/Button/Button";
import Version from 'components/Version/Version';
import { useAuth } from "providers/AuthProvider";
import { NavLink, useNavigate } from "react-router-dom";
import "./MainNav.scss";
import MainNavLink from "./MainNavLink";
import SubNavLink from "./SubNavLink";
import useMainNav from './useMainNav';

const MainNav = ({ userCreatedPages }) => {
	const navigate = useNavigate();
	const { isJesseAcct, isLoggedIn } = useAuth();
	const {
		signInOut,
    currentDateString,
    currentSlide,
    dayCreated,
    handleSlideNavClick,
    slideCount,
    slidesContainerRef,
    userCreatedPagesAtoZ,
    yesterdayDateString,
		setMainNavOpen,
	} = useMainNav({ userCreatedPages });
	
	return (
		<>
			<div className='mainnav'>
				<Version />
				<Button className='mainnav__register-device-button' element='button' onClick={() => {navigate('/register-device'); setMainNavOpen(false);}} text={(<DevicesIcon />)} />
				
				<div className='mainnav__slides-container' ref={slidesContainerRef}>
					<div className='mainnav__slide'>
						<MainNavLink label='Home' to='/' />
						<MainNavLink label='Dashboard' to='/dashboard' isPrivate />
						<MainNavLink label='Days' to={`/days`} isPrivate />
						<MainNavLink label='Today' to={dayCreated('today') ? `/days/edit/${currentDateString}` : '/days/create'} isPrivate />
						<MainNavLink label='Yesterday' to={dayCreated('yesterday') ? `/days/edit/${yesterdayDateString}` : '/days/create'} isPrivate />
						<MainNavLink label='Life' isPrivate>
							<SubNavLink label='Timeline' to={`/life/timeline`} />
						</MainNavLink>
						<MainNavLink label='Music'>
							<SubNavLink label='Albums' to={`/music/albums`} />
						</MainNavLink>
						<MainNavLink label='Tasks' to={`/tasks`} isPrivate />
						<MainNavLink label='Coin' to='/coin-flip' />
					</div>
					<div className='mainnav__slide'>
						{isJesseAcct && (
							<>
								<MainNavLink label='R2' isPrivate>
									<SubNavLink label='Tasks' to={`/r2/tasks`} />
									{userCreatedPagesAtoZ?.map(page => (page.pageParent.toLowerCase() === 'r2' && <SubNavLink key={page.id} label={page.title} to={`${page.pageParent.toLowerCase()}/${page.id}`} />))}
								</MainNavLink>
								<MainNavLink label='Sites'>
									{/* TODO: restore these pages: */}
									<SubNavLink label='Archives' to='http://archives.jessewhite.site' />
									<SubNavLink label='Hangman' to='http://hangman.jessewhite.site' />
								</MainNavLink>
								<MainNavLink label='Auto'>
									<SubNavLink label='Escape Tasks' to={`/auto/escape/tasks`} />
									<SubNavLink label='Ranger Tasks' to={`/auto/ranger/tasks`} />
									{userCreatedPagesAtoZ?.map(page => (page.pageParent.toLowerCase() === 'auto' && <SubNavLink key={page.id} label={page.title} to={`${page.pageParent.toLowerCase()}/${page.id}`} />))}
								</MainNavLink>
								<MainNavLink label='Family' isPrivate>
									{userCreatedPagesAtoZ?.map(page => (page.pageParent.toLowerCase() === 'family' && <SubNavLink key={page.id} label={page.title} to={`${page.pageParent.toLowerCase()}/${page.id}`} />))}
								</MainNavLink>
							</>
						)}
						<MainNavLink label='Notes' to={`/notes`} />
						<MainNavLink label='Food'>
							<SubNavLink label='Recipes' to={`/food/recipes`} />
						</MainNavLink>
						<MainNavLink label='Flash Cards'>
							<SubNavLink label='Play' to={`/flash-cards-game`} />
							<SubNavLink label='View All' to={`/flash-cards`} />
						</MainNavLink>
						<MainNavLink label='Phrases' to={`/phrases`} isPrivate />
						<MainNavLink label='Maxims' to={`/maxims`} isPrivate />
						<MainNavLink label='Wallpapers' to={`/wallpapers`} isPrivate />
					</div>
				</div>
			</div>

			<div className='mainnav__bottom-links'>
				<div className="mainnav__mainlink mainnav__mainlink--auth">
					<NavLink to="/auth" onClick={signInOut}> {isLoggedIn ? "Sign Out" : "Sign In"} </NavLink>
				</div>
				{slideCount > 0 && (
					<div className='mainnav__slide-nav'>
						<ul>
							{[...Array(slideCount)].map((_, index) => (
								<li
									key={index}
									className={index === currentSlide ? 'active' : ''}
									onClick={() => handleSlideNavClick(index)}>
								</li>
							))}
						</ul>
					</div>
				)}
			</div>
		</>
	);
};

export default MainNav;